<!-- @format -->

<template>
  <div>分析报告</div>
</template>

<script>
export default {}
</script>

<style scoped></style>
